import { FadeZoomIn } from '@components/ui/animations';
import styled from '@emotion/styled';

export const SadaKComment = styled(FadeZoomIn)`
  .ant-comment-avatar img {
    width: 24px;
    height: 24px;
  }
`;
